/** "October 13, 2026" for an ISO timestamp; null when missing or invalid. */
export function formatPreviewDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
}

export function initialOf(name: string): string {
  return (name.trim()[0] ?? "?").toUpperCase();
}
